import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import moment from "moment";
const initialFieldValues = {
  month: new Date(),
  cycle: "",
};
export default function GenerateTasks() {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const handleclear = () => {
    resetForm();
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const validate = () => {
    let temp = {};
    temp.cycle = values.cycle === "" ? false : true;
    temp.month = values.month === "" ? false : true;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const formData = new FormData();
      formData.append("Month", moment(values.month).format("YYYY-MM")); // Capital 'M'
      formData.append("Cycle", values.cycle); // Capital 'C'

      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(
          config.APIACTIVATEURL +
            config.CREATESERVICETASK +
            "?Month=" +
            moment(values.month).format("YYYY-MM") +
            "&Cycle=" +
            values.cycle,
          newrecord,
          {
            ...headerconfig,
          }
        ),
    };
  };
  const addOrEdit = (formData) => {
    {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            alert(res.data.data);
            resetForm();
          } else {
            alert(res.data.data);
          }
        })
        .catch(function (error) {
          alert("Error in saving data");
        });
    }
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Tasks</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Month</label>
                      <div className="input-group">
                        <Flatpickr
                          value={values.month}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m",
                            plugins: [
                              new (require("flatpickr/dist/plugins/monthSelect"))(
                                {
                                  shorthand: true,
                                  dateFormat: "M-Y",
                                  theme: "light",
                                }
                              ),
                            ],
                          }}
                          onChange={(date) =>
                            setValues({
                              ...values,
                              month: date[0],
                            })
                          }
                        />
                        <div className="input-group-text bg-primary border-primary text-white">
                          <i className="ri-calendar-2-line" />
                        </div>
                      </div>
                    </div>
                    {errors.month === false ? (
                      <div className="validationerror">Please select</div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="cycle" className="form-label">
                        Cycle
                      </label>
                      <select
                        name="cycle"
                        value={values.cycle}
                        onChange={handleInputChange}
                        className={"form-select" + applyErrorClass("cycle")}
                      >
                        <option value="0">Please Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Single">Single</option>
                      </select>
                      {errors.cycle === false ? (
                        <div className="validationerror">Please select</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button type="submit" className="btn btn-primary w-100">
                        Generate
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleclear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
